import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [username, setUsername] = useState("Guest");
  const [loggedIn, setLoggedIn] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const name = localStorage.getItem("userName");
    const token = localStorage.getItem("authToken");
    if (token && name) {
      setUsername(name || "User");
      setLoggedIn(true);
    } else {
      setUsername("Guest");
      setLoggedIn(false);
    }
  }, []);

  useEffect(() => {
    const handleUserChange = () => {
      const name = localStorage.getItem("userName");
      const token = localStorage.getItem("authToken");
      if (token && name) {
        setUsername(name || "User");
        setLoggedIn(true);
      } else {
        setUsername("Guest");
        setLoggedIn(false);
      }
    };

    window.addEventListener("userChanged", handleUserChange);
    return () => {
      window.removeEventListener("userChanged", handleUserChange);
    };
  }, []);

  const handleProfileClick = () => {
    setMenuOpen((open) => !open);
  };

  const handleSignOut = async () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("userName");
    localStorage.removeItem("userRole");
    localStorage.removeItem("userId");
    try {
      await signOut(auth);
    } catch {}
    setUsername("Guest");
    setLoggedIn(false);
    setMenuOpen(false);
    navigate("/signin");
  };

  const handleSignIn = () => {
    setMenuOpen(false);
    navigate("/signin");
  };

  return (
    <header
      className={`sticky top-0 inset-x-0 z-50 bg-white transition-all duration-200 ${
        scrolled ? "border-b border-slate-200 shadow-sm" : "border-b-0"
      }`}
    >
      <nav className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-20">
        <div className="flex h-16 items-center justify-between">
          {/* Brand */}
          <a href="/" className="flex items-center gap-3">
            <img
              src="/trent_logo.png"
              alt="Trent Limited logo"
              title="Trent Limited"
              className="h-8 md:h-9 w-auto select-none transition-opacity invert"
              draggable="false"
            />
          </a>

          {/* Right: Username & Profile */}
          <div className="flex items-center gap-4 relative">
            <span className="text-slate-700 font-medium text-sm">
              {username}
            </span>
            <img
              src="/profile_pic.jpg"
              alt="Profile"
              className="h-9 w-9 rounded-full ring-1 ring-slate-200 object-cover cursor-pointer"
              onClick={handleProfileClick}
            />
            {menuOpen && (
              <div className="absolute right-0 top-12 bg-white border border-slate-200 rounded-lg shadow-lg min-w-[140px] py-2 z-50">
                {loggedIn ? (
                  <button
                    className="block w-full text-left px-4 py-2 text-slate-700 hover:bg-slate-100"
                    onClick={handleSignOut}
                  >
                    Sign Out
                  </button>
                ) : (
                  <button
                    className="block w-full text-left px-4 py-2 text-slate-700 hover:bg-slate-100"
                    onClick={handleSignIn}
                  >
                    Sign In
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      </nav>
    </header>
  );
}